$('#btnAddNewsletterEmail').click(function() {

    $.ajax({
        type: 'POST',
        url: '/subscription/subscription/addnewsletteremail',
        async: true,
        cache: false,
        data: {
            email: $('#inputAddNewsletterEmail').val()
        },
        success: function(response) {
            var result = $.parseJSON(response);
            $('#newsletter-error-message').addClass('d-none');
            $('#newsletter-success-message').addClass('d-none');

            if (result.success === 'true') {
                $('#newsletter-success-message').removeClass('d-none');
                $('#newsletter-success-message').html(result.message);
                $('.addnewsletter-form').remove();
            } else {
                $('#newsletter-error-message').removeClass('d-none');
                $('#newsletter-error-message').html(result.message);
            }
        },
    });
});

